import React, { Component } from "react"
import { Route, Switch, Redirect } from "react-router-dom"
import Layout from "app/core/Layout"
import PgsApp from './pgs'
import PgdApp from './pgd'
import AzfApp from './azf'

import { inject, observer } from "mobx-react"
import "app/Index.scss"
import "app/styles/sass/modal.scss"
import "app/styles/sass/base.scss"
import "app/styles/less/ant-theme-vars.less"
import {setCurrentApp} from '../api/localTools'

class MainPanel extends Layout {
  renderContent () {
    return <div>{this.props.children}</div>
  }
}

@inject("auth", "entrance") @observer
export default class Main extends Component {
  componentDidMount () {
    const { auth } = this.props
    auth.needLoadApps && auth.getApps().then(this.setCurrentAppFromPath)
    auth.getPushAuth()
  }

  setCurrentAppFromPath = () => {
    const { apps } = this.props.auth

    apps.forEach(app => {
      if (window.location.pathname.includes(`/public/main/${app}`)) {
        setCurrentApp(app)
      }
    })
  }

  render () {
    const {match} = this.props
    return (
      <MainPanel>
        <Switch>
          <Route path={`${match.url}/pgs`} component={PgsApp} />
          <Route path={`${match.url}/pgd`} component={PgdApp} />
          <Route path={`${match.url}/azf`} component={AzfApp} />
          <Redirect from='*' to={`${match.url}/pgs`} />
        </Switch>
      </MainPanel>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/Main.js